import React from 'react'

const DefaultHeader = () => {
  return (
    <header className='login-header container-fluid bg-brand-2 py-5'>
      <div className='container h-100 container h-100 d-flex align-items-center'>
        <div id='logo' className='row logo w-100 h-100'>
          <div className='col-12 d-flex align-items-center justify-content-center pb-5'>
            <a
              id='image-link'
              href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`}
            >
              <p className='logo-header'>{`Logo ${process.env.RAZZLE_TITLE}`}</p>
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}

export default DefaultHeader
